import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import AppForAppPage from '@/pages/App/types/AppForAppPage';
import { scheduledBuildPath } from '@/utils/monolithApiRouteService';
import { queryClient } from '@/utils/query';

type DeleteScheduledBuildProps = {
  id: string;
  app: AppForAppPage;
};

const useDeleteScheduledBuild = ({ id, app }: DeleteScheduledBuildProps) => {
  return useMonolithApiMutation(
    scheduledBuildPath(id, {
      params: {
        build_trigger_token: app.buildTriggerToken,
      },
    }),
    'delete',
    {
      onSuccess: () => {
        queryClient.refetchQueries({ queryKey: ['scheduledBuilds', app.slug] });
      },
    },
  );
};

export default useDeleteScheduledBuild;
